/** PURE_IMPORTS_START .._operators_combineLatest PURE_IMPORTS_END */
import { CombineLatestOperator } from '../operators/combineLatest';
export function combineAll(project) {
    return function (source) { return source.lift(new CombineLatestOperator(project)); };
}
//# sourceMappingURL=combineAll.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/operators/combineAll.js
// module id = ./node_modules/rxjs/_esm5/operators/combineAll.js
// module chunks = vendor